/**
 * Local backup for the report-header config. Written whenever the user
 * saves in Header Designer, read whenever the server-side value is
 * missing/empty at report time.
 *
 * Purpose: users kept seeing the DEFAULT header ("MEDICAL CENTER HOSPITAL...")
 * on report open even though they'd designed a custom one. Root cause was
 * not identified for certain (candidate: settings.get returning stale/empty
 * for this user's session), so this belt-and-suspenders backup keeps their
 * design visible while we investigate the server path.
 *
 * Not authoritative - the server value always wins when present. This only
 * fills the gap.
 */

const LOCAL_KEY = 'edgeweb-report-header-cache';

export function cacheHeaderConfigLocally(json: string): void {
  try { localStorage.setItem(LOCAL_KEY, json); } catch { /* private mode / quota */ }
}

export function readCachedHeaderConfig(): string | null {
  try { return localStorage.getItem(LOCAL_KEY); } catch { return null; }
}

export function clearCachedHeaderConfig(): void {
  try { localStorage.removeItem(LOCAL_KEY); } catch {}
}
